export default "__VITE_ASSET__DEM5cduU__"